export const buildQueryParams = (params) =>
  Object.keys(params)
    .filter((k) => (params[k] !== undefined && params[k] !== null) && Object.keys(params).length !== 0)
    .reduce((q, k) => q + `${k}=${params[k]}&`, "?")
    .slice(0, -1);
